import React from 'react';
// No FontAwesome React imports needed when using the traditional syntax

const SocialIcons = () => {
  return (
    <div id="socialIcons" className="container">
      <div className="row">
        <div className="col-sm-12">
          <div className="social-icons">
            <h5>
              <a className="margin-r0" href="https://www.oxfordgolfresort.com/about-us.htm" target="_blank" rel="noopener noreferrer">About Us</a>&nbsp;&nbsp;|&nbsp;
              <a className="margin-r0" href="https://www.oxfordgolfresort.com/privacy-policy.htm" target="_blank" rel="noopener noreferrer">Privacy Policy</a>&nbsp;&nbsp;|&nbsp;
              <a className="margin-r0" href="https://www.oxfordgolfresort.com/terms-of-use.htm" target="_blank" rel="noopener noreferrer">Terms of Use</a>&nbsp;&nbsp;|&nbsp;
              <a className="margin-r0" href="https://www.oxfordgolfresort.com/club/contact-us.htm" target="_blank" rel="noopener noreferrer">Contact Us</a>
            </h5>
            <h5>Follow us</h5>
            <a href="https://www.facebook.com/oxfordgolfresort/?fref=ts" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-facebook-square fa-2x"></i>
            </a>
            <a href="https://www.instagram.com/oxfordgolfresortpune/" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-instagram fa-2x"></i>
            </a>
            <a href="https://www.linkedin.com/company/oxford-golf-retreat" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-linkedin-square fa-2x"></i>
            </a>
            <a href="https://twitter.com/ogrpune" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-twitter fa-2x"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialIcons;